// Cálculos para el posicionamiento dinámico del contenido de la card de la ficha de producto



function layoutActionsProduct() {

    const summary = document.querySelector(".summary.entry-summary");
    const btnContainer = document.querySelector(".summary-button-actions .form-buttons");
    const isMobile = window.innerWidth < 1024 ? true : false;

     if(!summary) {
        return;
     }

     if(isMobile) {
        // Desplazamiento de la card en mobile
        const btnContainerHeight = btnContainer.offsetHeight;
        const summaryTopHeight = summary.querySelector(".product_title_ref").offsetHeight;
        
        const marginTopCard = -(btnContainerHeight + summaryTopHeight);

        summary.setAttribute("style", `margin-top:${marginTopCard}px`)

        // Ajustes shipping container
        const shipingContainer = summary.querySelector(".summary-ship-info");
        const shipingHeight = shipingContainer.offsetHeight;

        shipingContainer.setAttribute("style", `margin-top:${shipingHeight}px`)

        // Ajustes de posición Support links
        const supportContainer = document.querySelector(".support-links");
        const moreAboutContainer = document.querySelector(".more-about");
        supportContainer.setAttribute("style", `margin-top:${shipingHeight}px`)
         if(moreAboutContainer){
           moreAboutContainer.setAttribute("style", `margin-top:${shipingHeight}px`)
         }
      }
    
}

layoutActionsProduct()
window.addEventListener('resize', function(event) {
    layoutActionsProduct()
});
